import { PayloadAction } from "@reduxjs/toolkit";
import { Toastify } from "../../components/Toaster";

export interface RTKSideEffectSchema {
  isLoading?: boolean;
  isUpdating?: boolean;
  isDeleting?: boolean;
  isResetting?: boolean;
  isAdding?: false;
  isSuccess?: boolean;
  isError?: boolean;
  error?: string;
}
export const successSideEffectState: RTKSideEffectSchema = {
  isLoading: false,
  isSuccess: true,
  isError: false,
  isUpdating: false,
  isDeleting: false,
  error: ""
};

const loadingSideEffectState: RTKSideEffectSchema = {
  isSuccess: false,
  isError: false,
  error: ""
};

const errorSideEffectState: RTKSideEffectSchema = {
  isLoading: false,
  isSuccess: false,
  isUpdating: false,
  isDeleting: false,
  isError: true
};
export const loadingSideEffects = {
  isLoading: true,
  isUpdating: false,
  isDeleting: false,
  isAdding: false,
  isSuccess: false,
  isError: false,
  errorMessage: null
};
export const defaultLoadingSideEffects = {
  isLoading: false,
  isDefaultLoading: true,
  isUpdating: false,
  isDeleting: false,
  isAdding: false,
  isSuccess: false,
  isError: false,
  errorMessage: null
};

export const defaultErrorSideEffects = {
  isLoading: false,
  isDefaultLoading: false,
  isUpdating: false,
  isDeleting: false,
  isResetting: false,
  isAdding: false,
  isSuccess: false,
  isError: true,
  errorMessage: null
};

export const defaultSuccessSideEffects = {
  isLoading: false,
  isDefaultLoading: false,
  isUpdating: false,
  isDeleting: false,
  isAdding: false,
  isSuccess: true,
  isError: false,
  errorMessage: null
};

export const successSideEffects = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isAdding: false,
  isSuccess: true,
  isResetting: false,
  isError: false,
  isContentUpdating: false,
  errorMessage: null
};

export const addingSideEffects = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isAdding: true,
  isSuccess: false,
  isError: false,
  errorMessage: null
};

export const errorSideEffects = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isAdding: false,
  isSuccess: false,
  isResetting: false,
  isError: true,
  errorMessage: null
};

export const updatingSideEffects = {
  isLoading: false,
  isUpdating: true,
  isDeleting: false,
  isAdding: false,
  isSuccess: false,
  isResetting: false,
  isError: false,
  errorMessage: null
};

export const deletingSideEffects = {
  isLoading: false,
  isUpdating: false,
  isDeleting: true,
  isAdding: false,
  isSuccess: false,
  isResetting: false,
  isError: false,
  errorMessage: null
};

export const resetingSideEffects = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isAdding: false,
  isSuccess: false,
  isError: false,
  isResetting: true,
  errorMessage: null
};

export const contentUpdatingSideEffects = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isAdding: false,
  isSuccess: false,
  isResetting: false,
  isError: false,
  isContentUpdating: true,
  errorMessage: null
};

const toastMap = {
  update: "Updated",
  delete: "Deleted",
  create: "Created"
};
export const createGenericReducers = <StateType, PayloadType>(props: { type?: string; stateLabel?: string }) => ({
  request: (state: StateType, _: PayloadAction<PayloadType>) => {
    return {
      ...state,
      ...loadingSideEffectState,
      isUpdating: props.type === "update",
      isDeleting: props.type === "delete",
      isLoading: !props.type
    };
  },
  success: (state: StateType, action: PayloadAction<PayloadType>) => {
    if (props.type) {
      Toastify("success", `${props.stateLabel} ${toastMap[props.type]} successfully`);
    }
    return {
      ...state,
      ...successSideEffectState,
      Data: action.payload
    };
  },
  failure: (state: StateType, action: PayloadAction<string>) => {
    Toastify("error", action.payload);
    return {
      ...state,
      ...errorSideEffectState,
      error: action.payload
    };
  }
});
